import helpers from '@/helpers';
import moment from 'moment';

export default {

    data() {
        return {
            date: {
                year: new Date().getFullYear(),
                month: new Date().getMonth()
            },
            allMarktimes: null,
            allVacations: null
        }
    },

    computed: {
        marktimes() {
            if (this.allMarktimes) return this.allMarktimes.filter((marktime) => marktime.month === this.date.month)
            return null
        }
    },

    methods: {
        getRemainingVacationDays(uid) {

            if (!this.allMarktimes) return null;

            var currentUser = this.users.filter(user => user.uid === uid)[0]
            var numOfVacDays = 0
            var currentUserMarktimes = this.allMarktimes.filter(marktime => marktime.user === uid && marktime.month < this.date.month)

            currentUserMarktimes.forEach(marktime => {
                marktime.marktime.forEach(day => {
                    if (day.type === 'D') {
                        if (day.halfday) numOfVacDays += 0.5
                        else numOfVacDays += 1
                    }
                })
            })

            if (uid && currentUser.totalVacationsDays) {
                return currentUser.totalVacationsDays - numOfVacDays
            }
            return null

        },

        getRemainingVacationDaysWithPlanned(uid) {

            var hoursTotal = 0;
			var vacationHours = {};
           

            if (!this.allMarktimes || !this.allVacations || !this.users) return null

            var currentUser = this.users.filter(user => user.uid === uid)[0]

            var workingHours = (currentUser.isPartTime) ? currentUser.partTime : 8;

            var userVacations = this.allVacations.filter(vacation => vacation.user === uid)
            var userMarktimes = this.allMarktimes.filter(marktime => marktime.user === uid)

            userVacations.forEach(vacation => {

                if (vacation.approved === undefined || vacation.approved === true || vacation.approved === null) {

                    var from = new Date(vacation.from.seconds * 1000);
                    var to = new Date(vacation.to.seconds * 1000);
                    var hours = parseFloat(vacation.hours);

                    for (var day = from; day <= to; day.setDate(day.getDate() + 1)) {

                        if (helpers.isHoliday(day) || helpers.isSunday(day) || helpers.isSaturday(day)) continue

                        if (hours >= workingHours) {
                            vacationHours[moment(day).format('YYYY-MM-DD')] = workingHours;
                            hours -= workingHours;
                        } else {
                            vacationHours[moment(day).format('YYYY-MM-DD')] = hours;
                        }
                    
                    }
                }

            });


            userMarktimes.forEach(marktime => {
                marktime.marktime.forEach((day, i) => {
                    if (day.type === 'D') {

                        var date = moment({
                            year: marktime.year,
                            month: marktime.month,
                            day: i + 1
                        }).format('YYYY-MM-DD');
                        
                        var hours = (day.halfday) ? workingHours / 2 : workingHours;
                        vacationHours[date] = hours;
                    }
                })
            })

            for (var i in vacationHours) {
                var date = moment(i, 'YYYY-MM-DD').toDate()
                if (helpers.isHoliday(date) || helpers.isSunday(date) || helpers.isSaturday(date)) continue
                hoursTotal += vacationHours[i]
            }

            return currentUser.totalVacationsDays - parseFloat(hoursTotal / workingHours)

        }
    }

}